import { render, staticRenderFns } from "./widgetIpsecTunnelTrafficTopn.vue?vue&type=template&id=aa2508d2&scoped=true&"
import script from "./widgetIpsecTunnelTrafficTopn.vue?vue&type=script&lang=js&"
export * from "./widgetIpsecTunnelTrafficTopn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2508d2",
  null
  
)

export default component.exports